import { getSanitizedHtml } from "../../util/getSanitizedHtml"
import PropType from 'prop-types';

const ReportOptionCheckbox = ({ value, label, checked, onChange, disabled }) => {

    return (
        <div className="form-check mb-3 d-flex align-items-center">
            <input
                disabled={disabled}
                className="form-check-input type-14 flex-shrink-0"
                type="checkbox"
                id={`checkbox--${value}`}
                value={value}
                checked={checked}
                onChange={() => onChange()}
            ></input>
            <label className="form-check-label type-14" htmlFor={`checkbox-sheet-options-includehcp-${value}`} dangerouslySetInnerHTML={getSanitizedHtml(label)}></label>
        </div>
    )
}

ReportOptionCheckbox.propTypes = {
    value: PropType.string,
    label: PropType.string,
    checked: PropType.bool,
    onChange: PropType.func,
    disabled: PropType.bool
}

export default ReportOptionCheckbox;